import React from 'react';
import { 
  Modal, 
  Box, 
  Button, 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem, 
  Typography, 
  Grid 
} from '@mui/material';

const PeriodSelectionModal = ({
  open,
  onClose,
  selectedPeriod1,
  selectedPeriod2,
  setSelectedPeriod1,
  setSelectedPeriod2,
  onFetchComparisonData,
  isLoadingComparison,
  direction,
  t
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="period-selection-modal-title"
    >
      <Box sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 600,
        bgcolor: 'background.paper',
        boxShadow: 24,
        borderRadius: '10px',
        p: 4,
      }}>
        <Typography variant="h6" component="h2" sx={{ mb: 3, textAlign: 'center' }}>
          {t('SelectPeriodsForComparison')}
        </Typography>

        <Grid dir={direction} container spacing={3}>
          {/* Period 1 */}
          <Grid item xs={6}>
            <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold' }}>
              {t('Period1')}
            </Typography>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>{t('Year')}</InputLabel>
              <Select
                value={selectedPeriod1.year}
                onChange={(e) => setSelectedPeriod1({...selectedPeriod1, year: e.target.value})}
                label={t('Year')}
              >
                {Array.from({length: 10}, (_, i) => new Date().getFullYear() - i).map(year => (
                  <MenuItem dir={direction} key={year} value={year}>{year}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>{t('StartMonth')}</InputLabel>
              <Select
                value={selectedPeriod1.startMonth}
                onChange={(e) => setSelectedPeriod1({...selectedPeriod1, startMonth: e.target.value})}
                label={t('StartMonth')}
              >
                {Array.from({length: 12}, (_, i) => i + 1).map(month => (
                  <MenuItem dir={direction} key={month} value={month}>{month}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel>{t('EndMonth')}</InputLabel>
              <Select
                value={selectedPeriod1.endMonth}
                onChange={(e) => setSelectedPeriod1({...selectedPeriod1, endMonth: e.target.value})}
                label={t('EndMonth')}
              >
                {Array.from({length: 12}, (_, i) => i + 1).map(month => (
                  <MenuItem dir={direction} key={month} value={month}>{month}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Period 2 */}
          <Grid item xs={6}>
            <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 'bold' }}>
              {t('Period2')}
            </Typography>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>{t('Year')}</InputLabel>
              <Select
                value={selectedPeriod2.year}
                onChange={(e) => setSelectedPeriod2({...selectedPeriod2, year: e.target.value})}
                label={t('Year')}
              >
                {Array.from({length: 10}, (_, i) => new Date().getFullYear() - i).map(year => (
                  <MenuItem dir={direction} key={year} value={year}>{year}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>{t('StartMonth')}</InputLabel>
              <Select
                value={selectedPeriod2.startMonth}
                onChange={(e) => setSelectedPeriod2({...selectedPeriod2, startMonth: e.target.value})}
                label={t('StartMonth')}
              >
                {Array.from({length: 12}, (_, i) => i + 1).map(month => (
                  <MenuItem dir={direction} key={month} value={month}>{month}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth>
              <InputLabel>{t('EndMonth')}</InputLabel>
              <Select
                value={selectedPeriod2.endMonth}
                onChange={(e) => setSelectedPeriod2({...selectedPeriod2, endMonth: e.target.value})}
                label={t('EndMonth')}
              >
                {Array.from({length: 12}, (_, i) => i + 1).map(month => (
                  <MenuItem dir={direction} key={month} value={month}>{month}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Box dir={direction} sx={{ display: 'flex', justifyContent: 'space-between', mt: 4 }}>
          <Button
            variant="outlined"
            onClick={onClose}
            sx={{ width: '120px' }}
          >
            {t('Cancel')}
          </Button>
          <Button
            variant="contained"
            onClick={onFetchComparisonData}
            disabled={isLoadingComparison}
            sx={{ width: '120px', backgroundColor: '#304FFF', '&:hover': { backgroundColor: '#304FFF' } }}
          >
            {isLoadingComparison ? t('Loading') : t('GenerateComparison')}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default PeriodSelectionModal;
